import { render, staticRenderFns } from "./RyuryoCompareWaterChart.vue?vue&type=template&id=139ddb12&scoped=true"
import script from "./RyuryoCompareWaterChart.vue?vue&type=script&lang=ts"
export * from "./RyuryoCompareWaterChart.vue?vue&type=script&lang=ts"
import style0 from "./RyuryoCompareWaterChart.vue?vue&type=style&index=0&id=139ddb12&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "139ddb12",
  null
  
)

export default component.exports